import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import AlertLevels from '../../../components/AlertLevels';
import { Space } from 'antd';

import styles from './index.scss';
import {
  convertISOToDateTimeFormat,
  convertISOToDateFormat
} from '../../../../../util/timezone';

export const ChampionOrChallengerBasicDetail = ({
  GS,
  data,
  title,
  children
}) => {
  const getChampionOrChallengerBasicDetail = (GS) => {
    const sortedSettings = orderBy(
      GS.widgetConfig,
      ['columnIndex'],
      ['asc']
    ).filter((column) => column.columnVisibility);
    return sortedSettings.map((setting, id) => {
      return (
        <div className={styles.list} key={id}>
          {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
            .filter((column) => column.visibility)
            .map((column, idx) => {
              if (column.itemName === 'alertLevels') {
                return (
                  <div style={{ width: '252px' }} key={idx}>
                    <div className={styles.list_key}>Alert Levels</div>
                    <AlertLevels data={data.alertLevels} />
                  </div>
                );
              } else if (
                column.itemName === 'executedAt' ||
                column.itemName === 'completedAt'
              ) {
                return (
                  <div key={idx} className={styles.list_item}>
                    <div className={styles.list_key}>
                      {column.itemLabel + ':'}{' '}
                    </div>
                    <div className={styles.list_value}>
                      {data[column.itemName]
                        ? convertISOToDateTimeFormat(data[column.itemName])
                        : '--'}
                    </div>
                  </div>
                );
              } else if (column.itemName === 'customerDateRange') {
                return (
                  <div key={idx} className={styles.list_item}>
                    <div className={styles.list_key}>
                      {column.itemLabel + ':'}{' '}
                    </div>
                    <div className={styles.list_value}>
                      <Space>
                        <span>
                          {data['customerStartDate']
                            ? convertISOToDateFormat(
                                data?.['customerStartDate']
                              )
                            : '--'}
                        </span>
                        to
                        <span>
                          {data['customerEndDate']
                            ? convertISOToDateFormat(data?.['customerEndDate'])
                            : '--'}
                        </span>
                      </Space>
                    </div>
                  </div>
                );
              } else
                return (
                  <div key={idx} className={styles.list_item}>
                    <div className={styles.list_key}>
                      {column.itemLabel + ':'}{' '}
                    </div>
                    <div className={styles.list_value}>
                      {data[column.itemName] ? data[column.itemName] : '--'}
                    </div>
                  </div>
                );
            })}
        </div>
      );
    });
  };

  return (
    <div className={styles.basicDetailsWrapper}>
      <h4>{title}</h4>
      {children}
      <div className={styles.container}>
        {getChampionOrChallengerBasicDetail(GS)}
      </div>
    </div>
  );
};

ChampionOrChallengerBasicDetail.defaultProps = {
  GS: {},
  data: {},
  title: ''
};

ChampionOrChallengerBasicDetail.propTypes = {
  GS: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired
};

export default ChampionOrChallengerBasicDetail;
